export default {
    Save: 'save',
    Send: 'send',
    Cancel: 'cancel',
    Confirm: 'confirm',
    Attachments: 'attachments',
}
